module.exports = __webpack_public_path__ + "static/media/head-bg.2e0c0c65.png";